import React from "react";

const ContactSpin = ({ isPDFlex, isMonopoly }) => {
  return (
    <ul>
      {isPDFlex ? (
        <>
          <li>
            Developed By: <span>Aavakar Solution</span>
          </li>
          <li>
            By email:{" "}
            <a
              href="mailto:parth@aavakar.com"
              className="__cf_email__"
              target="_blank"
              rel="noopener noreferrer"
            >
             parth@aavakar.com
            </a>
          </li>
        </>
      ) : isMonopoly ? (
        <>
          <li>
            Developer name: <span>Tushar Hirpara</span>
          </li>
          <li>
            By email:{" "}
            <a
              href="mailto:tusharhirpara22@gmail.com"
              className="__cf_email__"
              target="_blank"
              rel="noopener noreferrer"
            >
              tusharhirpara22@gmail.com
            </a>
          </li>
        </>
      ) : (
        <>
          <li>
            Developer name: <span>Nigam Dudhat</span>
          </li>
          <li>
            By email:{" "}
            <a
              href="mailto:nigamdudhat2024@gmail.com"
              className="__cf_email__"
              target="_blank"
              rel="noopener noreferrer"
            >
              nigamdudhat2024@gmail.com
            </a>
          </li>
        </>
      )}
    </ul>
  );
};

export default ContactSpin;
